import { createRootRoute, Outlet } from "@tanstack/react-router";

import { SvHeader } from "@/components";
import { SvFooter } from "@/components/SvFooter.tsx";

export const Route = createRootRoute({
  component: () => (
    <div className="w-full">
      <SvHeader />
      <Outlet />
      <SvFooter />
    </div>
  ),
});
